import * as yup from 'yup';

export const createValidationSchema = (): yup.AnyObjectSchema => {
  return yup.object({
    fromDate: yup
      .date()
      .nullable()
      .test({
        name: 'fromDate-validation',
        test: (value, allData) => {
          const { createError, path, parent } = allData;
          const noSelectedDate = !value && !parent?.toDate;
          if (noSelectedDate) {
            return createError({
              path,
              message: 'article.from_date_or_to_date_should_be_selected',
            });
          }
          return true;
        },
      }),
    price1: yup
      .number()
      .nullable()
      .test({
        name: 'price-validation',
        test: (value, allData) => {
          const { createError, path, parent } = allData;
          const { price2, price3, price4, price5, price6, price7, price8, price9, price10 } =
            parent || {};
          const noPrice =
            typeof value !== 'number' &&
            typeof price2 !== 'number' &&
            typeof price3 !== 'number' &&
            typeof price4 !== 'number' &&
            typeof price5 !== 'number' &&
            typeof price6 !== 'number' &&
            typeof price7 !== 'number' &&
            typeof price8 !== 'number' &&
            typeof price9 !== 'number' &&
            typeof price10 !== 'number';
          if (noPrice) {
            return createError({
              path,
              message: 'article.at_least_one_price_category_should_be_not_empty',
            });
          }
          return true;
        },
      }),
  });
};
